import http from '@/http'
import { montaUrl } from '@/util/url-util'

export function getVersions(filters) {
    let url = montaUrl(filters)
    return http.get(`/api/versions?${url}`)
}

export function edit(id,data) {
    return http.put(`/api/versions/${id}`,data)
}

export default {edit}